(function attachSocialLinkWidget(root, factory) {
  const catalog = root?.EpicSocialPlatformCatalog || (
    typeof module === "object" && module.exports ? require("./platformCatalog") : null
  );
  const widget = factory(catalog);

  if (typeof module === "object" && module.exports) {
    module.exports = widget;
  }

  if (root) {
    root.EpicSocialLinkWidget = widget;
  }
})(typeof window !== "undefined" ? window : globalThis, function createSocialLinkWidget(catalog) {
  function safeDestination(value) {
    return catalog?.parseWebUrl(value)?.href || null;
  }

  function publicImageUrl(accountUsername, assetId) {
    if (!accountUsername || !/^social_image_[a-f0-9]{32}$/.test(String(assetId || ""))) return null;
    return `/api/accounts/profile/${encodeURIComponent(accountUsername)}/social-widget-assets/${encodeURIComponent(assetId)}`;
  }

  function createIcon(documentRef, platform, item, options) {
    const icon = documentRef.createElement("img");
    icon.className = "u-social-link__icon";
    icon.alt = "";
    icon.setAttribute("aria-hidden", "true");
    const uploaded = publicImageUrl(options.accountUsername, item?.imageAssetId);
    const generic = catalog.resolvePlatform("custom").iconAsset;
    const sources = [uploaded, platform.iconAsset, generic]
      .filter((value, index, values) => value && values.indexOf(value) === index)
      .map((value) => options.assetOrigin === "https://ctek123.pro" && /^\/(?!\/)/.test(value)
        ? options.assetOrigin + value : value);
    let sourceIndex = 0;
    icon.src = sources[sourceIndex];
    icon.addEventListener("error", () => {
      sourceIndex += 1;
      if (sources[sourceIndex]) icon.src = sources[sourceIndex];
      else icon.hidden = true;
    });
    return icon;
  }

  function createSocialLink(documentRef, item, options = {}) {
    const destination = safeDestination(item?.url);
    if (!destination) return null;

    const platform = catalog.resolvePlatform(item?.platform);
    const anchor = documentRef.createElement("a");
    const size = ["small", "medium", "large"].includes(item?.size) ? item.size : "medium";
    anchor.className = `u-chip u-social-link u-social-link--${size}`;
    anchor.href = destination;
    anchor.target = "_blank";
    anchor.rel = "noopener noreferrer";
    anchor.dataset.platform = platform.key;
    anchor.append(createIcon(documentRef, platform, item, options));

    const label = documentRef.createElement("span");
    label.textContent = String(item?.label || platform.displayName || destination);
    anchor.append(label);
    return anchor;
  }

  function renderList(container, items, options = {}) {
    if (!container) return;
    const documentRef = container.ownerDocument || document;
    const links = (Array.isArray(items) ? items : [])
      .filter((item) => item?.visible !== false)
      .map((item) => createSocialLink(documentRef, item, options))
      .filter(Boolean);

    container.replaceChildren();
    container.classList.add("u-social-grid");
    if (links.length) {
      container.append(...links);
      return;
    }

    const empty = documentRef.createElement("p");
    empty.className = "u-muted";
    empty.textContent = options.emptyText || "No socials yet.";
    container.append(empty);
  }

  return Object.freeze({ createSocialLink, publicImageUrl, renderList, safeDestination });
});
